import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BaseChartDirective } from 'ng2-charts';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { FilterButtonComponent } from '../components/filter-button/filter-button.component';

import { CxDashboardComponent } from './cx-dashboard/cx-dashboard.component';
import { CxHomeRoutingModule } from './cx-home-routing.module';
import { CxHomeComponent } from './cx-home.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CxHomeRoutingModule,
    NgxDatatableModule,
    BaseChartDirective,
    SharedPipesModule,
    NgxTippyModule,
    FilterButtonComponent,
  ],
  declarations: [CxHomeComponent, CxDashboardComponent],
})
export class CxHomeModule {}
